import React, { Suspense, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { dequal } from 'dequal'
import { CTAItem } from '@typesApp/MyClaim'
import { ActionModule } from '@typesApp/ActionModule'
import { HostEnvironment, HostSession } from '@typesApp/Environment'
import {
  connectorMyClaimsSelector,
  connectorInitMyClaims,
} from '@redux/slices/connectorSlice'
import { useAppInit } from './useAppInit'
import { FallbackIndicator } from '@components/ui/Loader/FallbackIndicator'

const MyClaims = React.lazy(() => import('@components/MyClaims'))

interface MyClaimsAppProps {
  session: HostSession
  environment: HostEnvironment
  actionModule: ActionModule
  shoppingActions?: CTAItem[]
  onOrderClick?: (orderNumber: string) => Promise<void>
}

export const MyClaimsApp: React.FC<MyClaimsAppProps> = (props) => {
  const { shoppingActions = [], onOrderClick } = props
  const dispatch = useDispatch()
  const currentMyClaims = useSelector(connectorMyClaimsSelector)

  useAppInit(props)

  useEffect(() => {
    const myClaims = { shoppingActions, onOrderClick }

    if (!currentMyClaims || !dequal(currentMyClaims, myClaims)) {
      dispatch(connectorInitMyClaims(myClaims))
    }
  }, [shoppingActions, currentMyClaims])

  return (
    <Suspense fallback={<FallbackIndicator/>}>
      <MyClaims />
    </Suspense>
  )
}